export default __webpack_public_path__ + "static/media/RMS-DisclaimerCard-BPIDfromMDD.30c1d797.jpg";